import { createAction } from '@reduxjs/toolkit';

import type { UpdateExperimentalConfigPayload } from '@polyai/stream/commands/handlers/experimental-config';

const PREFIX = 'experimentalConfig';

const updateExperimentalConfig = createAction<UpdateExperimentalConfigPayload>(
  `${PREFIX}/updateExperimentalConfig`,
);

export { updateExperimentalConfig };
